import { Type } from 'src/components/base/MessagePane';

import { Flow } from 'src/services/runtime/flow';
import { selectRange } from 'src/services/runtime/runnable';

import { Data, StopReason } from 'src/services/flowstepExecution';

import { CancelError } from 'shared/utils/cancelToken';
import { NoDataError } from 'shared/utils/flowstep';


export async function execute(flows, meta) {
  for (const flow of flows) {
    const executor = createExecutor(flow, meta);
    const { error } = await executor.run();
    if (error) {
      break;
    }
  }
}


function createExecutor(flow, meta) {
  const executor = new Flow(flow, meta);
  const { requestStore } = meta.officeStore;

  function showPane(params, logRange = null) {
    logRange?.track();
    requestStore.showPane({ ...params, buttons: logRange
      ? [{ text: 'Go to log', onClick: async () => await selectRange(logRange) }]
      : [],  
    });
  }

  executor
    .on('started', (executor) => {
      executor.logger.log('Execution started')
    })
    .on('finished', (executor, result) => {
      const { logger } = executor;
      const { flowsteps, stopReason } = result;

      if (stopReason === StopReason.Normal) {
        const hasRealWarnings = flowsteps.some(flowstep => flowstep.result.warnings?.some(warning => !(warning instanceof NoDataError)))

        if (!hasRealWarnings) {
          logger.info(Data.successText);
        
          showPane({
            message: `Flow '${flow.name}' was successfully executed`,
            type: Type.Success,
            timeout: Data.messagePaneTimeout,
          });
        }
        else {
          const range = logger.warn('Successfully executed, but some errors were encountered');

          showPane({
            message: `Errors during execution of flow '${flow.name}' were encountered`,
            type: Type.Warning,
          }, range);
        }
        
        return;
      }

      if (stopReason === StopReason.User) {
        const range = logger.warn(`User decided to stop execution after flow step error`);

        showPane({
          message: `User decided to stop execution of flow '${flow.name}' after flow step error`,
          type: Type.Warning,
        }, range);
        return;
      }
      
      const text = `Flow execution stopped after a flow step encountered errors. You can set the flow step behavior on error to 'Continue' to ignore errors and continue flow execution`;
      const range = logger.error(text);

      showPane({
        message: `Execution of flow '${flow.name}' stopped after a flow step encountered errors. You can set the flow step behavior on error to 'Continue' to ignore errors and continue flow execution`,
        type: Type.Error, 
      }, range);
    })
    .on('error', (executor, error) => {
      const { logger, requestStore, flow } = executor;
    
      if (error instanceof CancelError) {
        logger.warn(`Execution was terminated by user`);
        requestStore.warn(`Execution of flow '${flow.name}' was terminated by user`, Data.messagePaneTimeout);
        return; 
      }
    
      console.log('Flow execution error: ', executor, error);
    
      const range = logger.error('Unable to execute flow');
      range?.track();
    
      requestStore.showPane({
        message:`${flow.name} - ${error.message}`,
        buttons: range
          ? [{ text: 'Go to log', onClick: async() => await selectRange(range) }]
          : [],
        type: Type.Error,
      });
    });
  
  return executor;
}